

const DEFAULT_SWAP_GAS_LIMIT = BigInt('300000');
const DEFAULT_APPROVAL_GAS_LIMIT = BigInt('80000');

function toBN(value, fallback = '0') {
  try {
    if (value == null || value === '') return BigInt(fallback);
    return BigInt(value);
  } catch {
    return BigInt(fallback);
  }
}

async function resolveGasPrice(provider, txData) {
  const fromTx = txData?.gasPrice || txData?.maxFeePerGas;
  if (fromTx) return toBN(fromTx);
  try {
    const fees = await provider.getFeeData();
    return fees.gasPrice ?? fees.maxFeePerGas ?? BigInt('1500000');
  } catch {
    return BigInt('1500000');
  }
}

async function estimateSwapGasLimit(provider, accountAddress, txData) {
  const fromTx = txData?.gas || txData?.gasLimit;
  if (fromTx) return toBN(fromTx, DEFAULT_SWAP_GAS_LIMIT.toString());

  try {
    return await provider.estimateGas({
      from: accountAddress,
      to: txData?.to,
      data: txData?.data,
      value: txData?.value || '0'
    });
  } catch {
    return DEFAULT_SWAP_GAS_LIMIT;
  }
}

export async function buildEthBalanceCheck({
  provider,
  accountAddress,
  mode,
  txData,
  valueRaw = '0',
  approvalCount = 0
}) {
  const ethBalance = await provider.getBalance(accountAddress);
  const gasPrice = await resolveGasPrice(provider, txData);
  const swapGasLimit = await estimateSwapGasLimit(provider, accountAddress, txData);
  const approvalGasLimit = DEFAULT_APPROVAL_GAS_LIMIT * BigInt(Math.max(0, Number(approvalCount || 0)));
  const totalGasLimit = swapGasLimit + BigInt(approvalGasLimit);
  const estimatedGasCost = totalGasLimit * BigInt(gasPrice);
  const requiredValue = toBN(valueRaw || txData?.value || '0');
  const requiredTotal = requiredValue + BigInt(estimatedGasCost);
  const missing = ethBalance < BigInt(requiredTotal) ? requiredTotal - BigInt(ethBalance) : BigInt(0);

  return {
    ok: missing === BigInt(0),
    mode,
    ethBalanceRaw: ethBalance.toString(),
    requiredValueRaw: requiredValue.toString(),
    estimatedGasCostRaw: estimatedGasCost.toString(),
    estimatedGasLimitRaw: totalGasLimit.toString(),
    gasPriceRaw: gasPrice.toString(),
    requiredTotalRaw: requiredTotal.toString(),
    missingRaw: missing.toString(),
    reason: missing === BigInt(0) ? null : mode === 'BUY' ? 'INSUFFICIENT_ETH_FOR_BUY_SWAP' : 'INSUFFICIENT_ETH_FOR_GAS'
  };
}

export function throwInsufficientBalanceError({ code, message, balanceCheck, requiredRaw, balanceRaw }) {
  const error = new Error(message);
  error.code = code;
  error.balanceCheck = balanceCheck || null;
  error.requiredRaw = requiredRaw || balanceCheck?.requiredTotalRaw || null;
  error.balanceRaw = balanceRaw || balanceCheck?.ethBalanceRaw || null;
  error.missingRaw = balanceCheck?.missingRaw || null;
  return error;
}
